import React from 'react'
import HomeIcon from '@mui/icons-material/Home'
import AttachMoneyIcon from '@mui/icons-material/AttachMoney'
import ViewComfyIcon from '@mui/icons-material/ViewComfy'
import PersonIcon from '@mui/icons-material/Person'
import AccountBoxIcon from '@mui/icons-material/AccountBox'
import ReceiptIcon from '@mui/icons-material/Receipt'
import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolder'
import BakeryDiningIcon from '@mui/icons-material/BakeryDining'
import CampaignIcon from '@mui/icons-material/Campaign'
import LoyaltyIcon from '@mui/icons-material/Loyalty'
import AddIcon from '@mui/icons-material/Add'
import StorageIcon from '@mui/icons-material/Storage'
import Inventory2Icon from '@mui/icons-material/Inventory2'
import BackpackIcon from '@mui/icons-material/Backpack'
import AccountTreeIcon from '@mui/icons-material/AccountTree'
import AutoAwesomeMotionIcon from '@mui/icons-material/AutoAwesomeMotion'
import BlurLinearIcon from '@mui/icons-material/BlurLinear'
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import WarehouseIcon from '@mui/icons-material/Warehouse'
import LocalShippingIcon from '@mui/icons-material/LocalShipping'
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn'
import DescriptionIcon from '@mui/icons-material/Description'
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow'
import PaidIcon from '@mui/icons-material/Paid'
import CurrencyPoundIcon from '@mui/icons-material/CurrencyPound'

const PagesIndex = () => {
	return {
		pages:{
			app:[
				{ name:"Tiendas", link:'/stores', icon:(<BlurLinearIcon/>)},
				{ name:"Paquetes", link:'/bundles', icon:(<AutoAwesomeMotionIcon/>)},
				{ name:"Estados de plataforma", link:'/platformstatuses', icon:(<AccountTreeIcon/>)},
				{ name:"Costos de plataforma", link:'/platformcostcalculations', icon:(<RequestQuoteIcon/>)},
				{ name:"Monedas", link:'/currencies', icon:(<CurrencyPoundIcon/>)},
				{ name:"Sincronizar Productos", link:'/update-products' , icon:(<AttachMoneyIcon/>)},
				{ name:"Alta de Productos", link:'/listings', icon:(<AddIcon/>)},
				{ name:"Proveedores", link:'/suppliers', icon:(<AccountBoxIcon/>)},
				{ name:"Clientes", link:'/clients', icon:(<PersonIcon/>)},
				{ name:"Productos", link:'/products' , icon:(<ViewComfyIcon/>)},
			],
			processes:[
				{ name:"Liquidaciones", link:'/liquidations', icon:(<CreateNewFolderIcon/>)},
				{ name:"Requisiciones", link:'/requisitions', icon:(<BackpackIcon/>)},
				//{ name:"Eventos de Venta", link:'/events', icon:(<Inventory2Icon/>)},
			],
			salesChannels:[
				{ name:"Almacenamiento", link:'/externalwarehousing', icon:<StorageIcon/>},
				{ name:"Envios a almacén", link:'/fba', icon:(<HomeIcon/>)},
				{ name:"Costos Extra", link:'/costs', icon:(<LoyaltyIcon/>)},
				{ name:"Campañas Clientes", link:'/campaigns', icon:(<BakeryDiningIcon/>)},
				{ name:"Campañas Productos", link:'/productPublicities', icon:(<CampaignIcon/>)},
				{ name:"Rastreo", link:'/guides', icon:(<ReceiptIcon/>)},
			],
			inventories:[
				//{name:'Inventarios', link:'/inventories', icon:(<AssignmentTurnedInIcon/>)},
				//{name:'Almacenes', link:'/warehouses', icon:(<WarehouseIcon/>)},
				//{name:'Envío a canal', link:'/salesChannelShippment', icon:(<LocalShippingIcon/>)},
				{name:'Capital en inventario', link:'/invenotriesCapital', icon:(<PaidIcon/>)},
			],
			metrics:[
				{name:'Productos', link:'/productMetrics', icon:(<DescriptionIcon/>)},
				{name:'Canales de venta', link:'/salesChannelMetrics', icon:(<DoubleArrowIcon/>)},
			]
		},
		neededData:{
			platformcostcalculations: ['/platformcostcalculations'],
			platformstatuses: ['/platformstatuses'],
			bundles: ['/bundles', '/clients'],
			suppliers: ['/suppliers', '/products', '/update-products', ],
			currencies: ['/currencies', '/products', '/update-products', ],
			clients: ['/clients', '/products', '/fba', '/costs', '/campaigns', '/update-products',],
			products: ['/products', '/externalwarehousing', '/inventories'],
			events: ['/events'],
			guides: ['/guides'],
			publicityCampaigns:['/campaigns'],
			productPublicities:['/productPublicities'],
			externalwarehousingCosts: ['/externalwarehousing'],
			stockCosts: ['/fba'],
			extraCosts: ['/costs'],
			inventories: ['/inventories'],
			warehouses: ['/warehouses', '/inventories', '/salesChannelShippment'],
			address: ['/warehouses'],
			metrics: [ '/productMetrics', '/salesChannelMetrics' ],
			groupedSales: [ '/liquidations' ],
		},
	}
}

export default PagesIndex